
export const oilChangeApiNm = {
  getOilChange: "/oil-change/getOilChange",
  getOilChangeDetail: "/oil-change/getOilChangeDetail",
  insertOilChange: "/oil-change/insertOilChange",
  updateOilChangeColumn: "/oil-change/updateOilChangeColumn",
  deleteOilChange: "/oil-change/deleteOilChange",
  getOilChangeDue: "/oil-change/getOilChangeDue",
  uploadOilChangeFile: "/oil-change/uploadOilChangeFile",
  deleteOilChangeFile: "/oil-change/deleteOilChangeFile",
}

export const oilChangeColNm = {
  TukId: "รถ",
  SpId: "น้ำมัน",
  ChgDte: "วันที่เปลี่ยน",
  Mileage: "เลขไมล์ (กม.)",
  Qty: "ปริมาณ (ลิตร)",
  UntPr: "ราคา/ลิตร",
  TotalPr: "ราคารวม",
  NxtMileage: "เปลี่ยนครั้งถัดไป (กม.)",
  MileageIntv: "ระยะเปลี่ยน (กม.)",
  NxtDte: "เปลี่ยนครั้งถัดไป (วัน)",
  DteIntv: "ระยะเปลี่ยน (วัน)",
  SupId: "ผู้จำหน่าย",
  DocNo: "เลขที่เอกสาร",
  DocDte: "วันที่เอกสาร",
  Dscp: "รายละเอียด",
  Rmk: "หมายเหตุ",
}
